/** Shared grouping + value interpretation for block-definition key/value properties. */
export const PROPERTY_GROUPS = [
  { key: "extrusions", label: "Extrusions", pattern: /pr/i },
  { key: "gaskets", label: "Gaskets", pattern: /gs/i },
  { key: "fasteners", label: "Fasteners", pattern: /fst/i },
  { key: "anchors", label: "Anchors", pattern: /anc/i },
];

/** A model key joins the first group whose token it contains (case-insensitive). */
export function groupKeyFor(propKey) {
  const found = PROPERTY_GROUPS.find((group) => group.pattern.test(propKey));
  return found ? found.key : "other";
}

/** Number-only values are quantities; "<number>mm" values are lengths. */
export function interpretValue(value) {
  const text = (value ?? "").toString().trim();
  if (/^\d+(?:[.,]\d+)?$/.test(text)) return { kind: "quantity", display: `×${text}` };
  const mm = /^(\d+(?:[.,]\d+)?)\s*mm$/i.exec(text);
  if (mm) return { kind: "length", display: `${mm[1]} mm` };
  return { kind: "text", display: text || "—" };
}

/** Numeric interpretation for math: quantity (number-only) or length ("<n>mm"). */
export function measureAmount(value) {
  const text = (value ?? "").toString().trim();
  if (/^\d+(?:[.,]\d+)?$/.test(text))
    return { kind: "quantity", amount: parseFloat(text.replace(",", ".")) };
  const mm = /^(\d+(?:[.,]\d+)?)\s*mm$/i.exec(text);
  if (mm) return { kind: "length", amount: parseFloat(mm[1].replace(",", ".")) };
  return { kind: "text", amount: null };
}
